// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_lx-1";
export var rowFirst = "_lx-3";
export var rowLast = "_lx-5";
export var rowMiddle = "_lx-4";
export var ticketListScroll = "_lx-2";
export var ticketStack = "_lx-0";